import { useMutation, useQuery } from '@tanstack/react-query';
import { webgwjsInstance } from '../redux/request/request';
import { getAccessToken } from "../helpers/authHelper";

type CheckEmailResponse = Partial<{
  accountId: number
  upnEmail: string
  accountEnabled: boolean
  authMode: string
  superPlusAdmin: boolean
  authenticationPath: string
  redirectUrl: string
}>;

type CheckEmailVariables = {
  upnEmail: string
};

const useCheckEmail = (options = {}) => useMutation({
  mutationFn: async ({ upnEmail }: CheckEmailVariables) => {
    console.log(upnEmail)
    const response = await webgwjsInstance.post<CheckEmailResponse>(
      '/api/v1/user/login/email-pre-check',
      { upnEmail },
    );

    return response.data;
  },
  ...options,
});

export type PermissionData = {
  roleCode?: string
  sections?: {
    section?: string
    functions?: {
      function?: string,
      permissionCode?: string,
    }[]
  }[]
}

type PermissionsResponse = {
  data?: PermissionData
}

const usePermissions = (options = {}) => useQuery({
  queryKey: ['permissions'],
  queryFn: async () => {
    const response = await webgwjsInstance.get<PermissionsResponse>(
      '/api/v1/cms/me/permissions',
      {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  },
  ...options,
});

export { useCheckEmail, usePermissions };
